export default "__VITE_PUBLIC_ASSET__e70ac9d9__"